module.exports = __webpack_public_path__ + "static/cercazone_hero2-1c190c5aeaa4b2b93785de4f1d181ad4.jpg";